import { render, staticRenderFns } from "./FormCheckboxTag.vue.js?vue&type=template&id=60008051!=!../../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FormCheckboxTag.vue?vue&type=template&id=60008051"
import script from "./FormCheckboxTag.vue.js?vue&type=script&lang=js!=!../../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FormCheckboxTag.vue?vue&type=script&lang=js"
export * from "./FormCheckboxTag.vue.js?vue&type=script&lang=js!=!../../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FormCheckboxTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports